import styled from 'styled-components';

export const ListPageItem = styled.ul.attrs({ className: 'ListPageItem' })`
  display: flex;
  padding-left: 0;
  list-style: none;
  justify-content: center;
`;
